import { createStateSyncMiddleware } from "redux-state-sync";
import { ADD_COMPARISON, DELETE_COMPARISON, } from "@Store/Actions/Customers/comparisons";
const config = {
    whitelist: [ADD_COMPARISON, DELETE_COMPARISON],
    channel: "uniqueNameTest",
};
export default createStateSyncMiddleware(config);
